import { ContentBlock, ContentBlockShape, ContentBlockType } from "../models";

const contentBlockHasPrompt = (
    contentBlock: ContentBlock | ContentBlockShape,
) => {
    return (
        contentBlock.content_block_type === ContentBlockType.Question &&
        contentBlock.prompt &&
        Object.keys(contentBlock.prompt) &&
        Object.keys(contentBlock.prompt).length > 0
    );
};

export const contentBlockHasChildren = (
    contentBlock: ContentBlock | ContentBlockShape,
) => {
    return (
        contentBlock?.contentBlocks !== undefined &&
        contentBlock?.contentBlocks?.length > 0
    );
};

export const getPromptsFromContentBlocks = (
    contentBlocks: (ContentBlock | ContentBlockShape)[],
) => {
    return contentBlocks?.length
        ? contentBlocks
              .filter((contentBlock) => contentBlockHasPrompt(contentBlock))
              .map((contentBlock) => contentBlock.prompt)
        : [];
};

// Finds all Question-type descendants of a form block at any depth, using a
// flat id→block map. Stops descent at nested Form blocks so questions owned
// by a child form are not pulled up into the ancestor form.
// Handles HTML-imported structures where questions may be wrapped in arbitrary
// layers of IMPORT_BLOCK containers rather than being direct children of a form.
export const getDescendantQuestionBlocks = (
    formBlockId: string,
    allBlocksById: Record<string, ContentBlock | ContentBlockShape>,
): (ContentBlock | ContentBlockShape)[] => {
    const results: (ContentBlock | ContentBlockShape)[] = [];

    const childrenByParentId: Record<string, string[]> = {};
    for (const block of Object.values(allBlocksById)) {
        const parentId = block.parent_content_block_id;
        if (parentId) {
            if (!childrenByParentId[parentId]) {
                childrenByParentId[parentId] = [];
            }
            childrenByParentId[parentId].push(block.id);
        }
    }

    const visit = (blockId: string) => {
        for (const childId of childrenByParentId[blockId] ?? []) {
            const child = allBlocksById[childId];
            if (!child) continue;
            if (child.content_block_type === ContentBlockType.Question) {
                results.push(child);
            } else if (child.content_block_type !== ContentBlockType.Form) {
                visit(childId);
            }
        }
    };

    visit(formBlockId);
    return results;
};
